export default ".input-text {\n  width: 100% !important;\n}"